import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SubletService {
  private showSubletSubject = new BehaviorSubject<boolean>(false);
  showSublet$ = this.showSubletSubject.asObservable();

  public selectedOptionsSubject = new BehaviorSubject<any[]>([]);
  selectedOptions$ = this.selectedOptionsSubject.asObservable();

  private apiUrl = `${environment.apiUrl}/api/sublets`;
  constructor(private http: HttpClient){}

  getSubletTasks(): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/sublet-tasks`);
  }

  addSubletTask(subletTask: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/sublet-tasks`, subletTask);
  }

  updateSubletTask(id: string, subletTask: any): Observable<any> {
    return this.http.put(`${this.apiUrl}/sublet-tasks/${id}`, subletTask);
  }

  toggleSublet() {
    this.showSubletSubject.next(!this.showSubletSubject.value);
  }

  closeSublet() {
    this.showSubletSubject.next(false);
  }

  openSublet() {
    this.showSubletSubject.next(true);
  }

  addOption(option: any) {
    const currentOptions = this.selectedOptionsSubject.value;
    this.selectedOptionsSubject.next([...currentOptions, option]);
  }

  removeOption(option: any) {
    const updatedOptions = this.selectedOptionsSubject.value.filter(o => o !== option);
    this.selectedOptionsSubject.next(updatedOptions);
  }

  resetOptions() {
    this.selectedOptionsSubject.next([]);
  }
}
